import { apiClient } from '@/shared/api';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type { GetAccountApiTokensResponse } from '../model';

const getAccountApiTokens = async (
  accountNumber: string,
  options?: RequestHandlerOptions
) => {
  const request = () =>
    apiClient.get(`/security/trading/webapi/token?acc=${accountNumber}`);
  const response = await handleRequest<GetAccountApiTokensResponse>(
    request,
    options
  );
  return response.data;
};

export { getAccountApiTokens };
